var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.62 24.058v-.264l.122.132-.122.132zm-32.694 6.794A6.933 6.933 0 014 23.926 6.933 6.933 0 0110.926 17a6.933 6.933 0 016.925 6.926 6.932 6.932 0 01-6.925 6.926zm34.913-7.606l-6.441-6.936-1.465 1.361 4.88 5.255H19.792C19.293 18.474 15.51 15 10.926 15 6.004 15 2 19.004 2 23.926c0 4.922 4.004 8.926 8.926 8.926 4.584 0 8.367-3.474 8.866-7.926h23.021l-4.88 5.255 1.465 1.361 6.441-6.935a1 1 0 000-1.361z",
    fill: "#D45B07",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEip);
export default __webpack_public_path__ + "static/media/eip.bbdef7b2fab7476dfe9abc69427c3c2f.svg";
export { ForwardRef as ReactComponent };